var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_user-agent.js
// module id = 118
// module chunks = 39